module.exports = __webpack_public_path__ + "static/img/Store-12.b936b7db.png";